import { API_URL } from "./settings";

export default function loginUser({ username, password }: { username: string; password: string }) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username: username, password: password }),
  };

  return fetch(`${API_URL}/api/auth/login`, requestOptions)
    .then((res) => {
      if (res.status === 401) {
        throw new Error("Usuario o contraseña no validos");
      } 
      if (!res.ok) {
        throw new Error("Error al iniciar sesión");
      }
      return res.json();
    })
    .catch((exception) => {
        throw new Error(
           exception.message
        );
    });
}
